<template>
  <div>
    <section class="invoice-preview-wrapper">
      <b-row class="invoice-preview justify-content-center">
        <b-col cols="10">
          <b-card no-body class="invoice-preview-card">
            <!-- Header -->
            <b-card-body class="invoice-padding pb-0">
              <div
                class="d-flex justify-content-center flex-md-row flex-column mt-0"
              >
                <!-- Title -->
                <div class="text-center">
                  <h1 class="invoice-logo">{{ this.userData.username }}</h1>
                  <h1 class="invoice-logo">Profit and Loss</h1>
                  <h3>01 Jan 2025 - 31 Dec 2025</h3>
                </div>
              </div>
            </b-card-body>

            <!-- Spacer -->
            <hr class="invoice-spacing" />

            <!-- section:asset -->
            <b-card-body class="invoice-padding py-0">
              <b-row class="invoice-spacing">
                <b-col cols="12" class="p-0">
                  <h5 class="text-uppercase" v-b-toggle.assets>
                    <u>INCOMES</u>
                  </h5>
                </b-col>
                <b-collapse visible id="assets" class="row w-100">
                  <!-- <b-col cols="12">
                    <h5 class="text-capitalize">Current Assets:</h5>
                  </b-col> -->
                  <!-- current assets -->
                  <b-row class="w-100">
                    <b-col cols="6" class="py-0 pr-0 pl-3">
                      <p class="card-text mb-25">Sales</p>
                    </b-col>
                    <b-col
                      xl="6"
                      cols="6"
                      class="p-0 mt-xl-0 mt-2 d-flex justify-content-end"
                    >
                      <div
                        class="font-weight-bolder justify-content-end text-right"
                      >
                        <p class="card-text mb-25">
                          {{ this.currency }}
                          {{ Number(this.profitandloss.sales).toFixed(2) }}
                        </p>
                      </div>
                    </b-col>
                  </b-row>

                  <b-col cols="12">
                    <h5 class="text-capitalize">Other Incomes:</h5>
                  </b-col>

                  <b-row
                    class="w-100"
                    v-for="(asset, index) in this.profitandloss.otherIncomes"
                    :key="index"
                  >
                    <b-col cols="6" class="py-0 pr-0 pl-3">
                      <p class="card-text mb-25">{{ asset.name }}</p>
                    </b-col>
                    <b-col
                      xl="6"
                      cols="6"
                      class="p-0 mt-xl-0 mt-2 d-flex justify-content-end"
                    >
                      <div
                        class="font-weight-bolder justify-content-end text-right"
                      >
                        <p class="card-text mb-25">{{ asset.total }}</p>
                      </div>
                    </b-col>
                  </b-row>

                  <!-- current assets -->
                  <!-- long term assets -->

                  <!-- <b-col cols="12">
                    <h5 class="text-capitalize">Cost of Goods Sold:</h5>
                  </b-col>
                  <b-row class="w-100">
                    <b-col cols="6" class="py-0 pr-0 pl-3">
                      <p class="card-text mb-25">COGS</p>
                    </b-col>
                    <b-col
                      xl="6"
                      cols="6"
                      class="p-0 mt-xl-0 mt-2 d-flex justify-content-end"
                    >
                      <div
                        class="font-weight-bolder justify-content-end text-right"
                      >
                        <p class="card-text mb-25">
                          {{ this.currency }}
                          {{
                            Number(this.profitandloss.costOfGoods).toFixed(2)
                          }}
                        </p>
                      </div>
                    </b-col>
                  </b-row> -->

                  <!-- long term assets -->
                </b-collapse>
                <b-row class="w-100">
                  <!-- total section -->
                  <b-col cols="6" class="mt-2">
                    <h5 class="text-uppercase">GROSS PROFIT</h5>
                  </b-col>

                  <b-col
                    cols="6"
                    class="mt-xl-2 mt-2 d-flex justify-content-end"
                  >
                    <div
                      class="font-weight-bolder justify-content-end text-right"
                    >
                      <hr class="my-50" />
                      <p class="card-text mb-25">
                        {{ this.currency }}
                        {{
                          (
                            Number(this.profitandloss.sales) +
                            this.profitandloss.otherIncomes.reduce(
                              (acc, asset) => acc + asset.total,
                              0
                            ) 
                          ).toFixed(2)
                        }}
                      </p>

                      <hr class="my-25" />
                      <hr class="my-25" />
                    </div>
                  </b-col>
                  <!-- total section -->
                </b-row>
              </b-row>
            </b-card-body>
            <!-- section:asset ends -->
            <!-- section:liabilities -->
            <b-card-body class="invoice-padding py-0">
              <b-row class="invoice-spacing">
                <b-col cols="12" class="p-0">
                  <h5 v-b-toggle.liabilities class="text-uppercase">
                    <u>EXPENSES</u>
                  </h5>
                </b-col>

                <!-- <b-row class="w-100">
                  <b-col cols="6" class="py-0 pr-0 pl-3">
                    <p class="card-text mb-25">Tax</p>
                  </b-col>
                  <b-col
                    xl="6"
                    cols="6"
                    class="p-0 mt-xl-0 mt-2 d-flex justify-content-end"
                  >
                    <div
                      class="font-weight-bolder justify-content-end text-right"
                    >
                      <p class="card-text mb-25">
                        {{ this.currency }}
                        {{ Number(this.profitandloss.taxExpenses).toFixed(2) }}
                      </p>
                    </div>
                  </b-col>
                </b-row> -->
                <b-row class="w-100">
                  <b-col cols="6" class="py-0 pr-0 pl-3">
                    <p class="card-text mb-25">Expenses</p>
                  </b-col>
                  <b-col
                    xl="6"
                    cols="6"
                    class="p-0 mt-xl-0 mt-2 d-flex justify-content-end"
                  >
                    <div
                      class="font-weight-bolder justify-content-end text-right"
                    >
                      <p class="card-text mb-25">
                        {{ this.currency }}
                        {{ Number(this.profitandloss.expenses).toFixed(2) }}
                      </p>
                    </div>
                  </b-col>
                </b-row>

                <b-col cols="12">
                  <h5 class="text-capitalize">Other Expenses:</h5>
                </b-col>

                <b-row
                  class="w-100"
                  v-for="(asset, index) in this.profitandloss.otherExpenses"
                  :key="index"
                >
                  <b-col cols="6" class="py-0 pr-0 pl-3">
                    <p class="card-text mb-25">{{ asset.name }}</p>
                  </b-col>
                  <b-col
                    xl="6"
                    cols="6"
                    class="p-0 mt-xl-0 mt-2 d-flex justify-content-end"
                  >
                    <div
                      class="font-weight-bolder justify-content-end text-right"
                    >
                      <p class="card-text mb-25">{{ asset.total }}</p>
                    </div>
                  </b-col>
                </b-row>
              </b-row>
            </b-card-body>
            <!-- section:liabilities ends -->
            <!-- section:equity -->

            <!-- section:equity ends -->
            <b-row class="w-100">
              <!-- grand total section -->
              <b-card-body class="invoice-padding py-0">
                <b-row class="invoice-spacing">
                  <!-- total section -->
                  <b-col cols="6" class="">
                    <h5 class="text-uppercase">NET PROFIT & LOSS</h5>
                  </b-col>

                  <b-col
                    cols="6"
                    class="mt-xl-0 mt-2 d-flex justify-content-end"
                  >
                    <div
                      class="font-weight-bolder justify-content-end text-right"
                    >
                      <hr class="my-50" />
                      <p class="card-text mb-25">
                        {{ this.currency }}
                        {{
                          (
                            Number(this.profitandloss.sales +  this.profitandloss.otherIncomes.reduce(
                              (acc, asset) => acc + asset.total,
                              0
                            )) -
            
                            (Number(this.profitandloss.expenses) +
                              +this.profitandloss.otherExpenses.reduce(
                                (acc, asset) => acc + asset.total,
                                0
                              ) +
                              Number(this.profitandloss.taxExpenses))
                          ).toFixed(2)
                        }}
                      </p>

                      <hr class="my-25" />
                      <hr class="my-25" />
                    </div>
                  </b-col>
                  <!-- total section -->
                </b-row>
              </b-card-body>
              <!-- grand total section -->
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </section>
  </div>
</template>

<script>
import {
  BButton,
  BTable,
  BRow,
  BCol,
  BCard,
  BCardBody,
  BFormGroup,
  VBTooltip,
  BContainer,
  BCardHeader,
  BCollapse,
  BTableLite,
  VBToggle,
} from "bootstrap-vue";
import jsPDF from "jspdf";
import "jspdf-autotable";
import Flatpickr from "vue-flatpickr-component";
import vSelect from "vue-select";
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import category from "@/router/routes/category";
import { AccountType, AccountCategory } from "@/libs/defaultList";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    BButton,
    BTable,
    BRow,
    BCol,
    BCard,
    BCardBody,
    Flatpickr,
    BFormGroup,
    vSelect,
    BContainer,
    BCardHeader,
    BCollapse,
    AppCollapse,
    AppCollapseItem,
    BTableLite,
    VBToggle,
  },
  directives: {
    "b-tooltip": VBTooltip,
    "b-toggle": VBToggle,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("userData")),
      accountType: AccountType,
      accountCategory: AccountCategory,
      currency: "Rs",

      dateFrom: "2025-01-01",
      dateTo: "2025-12-31",
    };
  },
  computed: {
    ...mapGetters("reportModule", {
      balancesheet: "balancesheet",
      profitandloss: "profitandloss",
      loading: "loading",
    }),
  },
  methods: {
    ...mapActions("reportModule", [
      "getBalanceSheetReportAction",
      "getProfitAndLossReportAction",
    ]),

    getAccountTypeValue(name) {
      const type = this.accountType.find((type) => type.label === name);
      return type ? type.value : null;
    },
    exportAsPDF() {
      const doc = new jsPDF();
      doc.text("Trial Balance", 10, 10);
      doc.autoTable({
        head: [["Account", "Debit", "Credit"]],
        body: this.tableData.map(({ account, debit, credit }) => [
          account,
          debit,
          credit,
        ]),
        startY: 20,
      });
      doc.save("pnl.pdf");
    },

    tbodyTrClass(item, rowIndex) {
      if (item.account === "Total (MUR)") {
        return "total-row font-weight-bolder bg-secondary bg-darken-5";
      }
      return "";
    },
  },
  async mounted() {
    // console.log("date", this.dateFrom);
    await this.getProfitAndLossReportAction({
      dateFrom: this.dateFrom,
      dateTo: this.dateTo,
    });
    console.log("profitandloss", this.userData);
  },
};
</script>

<style lang="scss" scoped>
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "~@core/scss/base/pages/app-invoice.scss";
</style>
